import styled from 'styled-components';

const CustomizationContainer = styled.div`
  width: 100%;
  max-width: 485px;
  margin: 0 auto;
`;

export default CustomizationContainer;
